export default __webpack_public_path__ + "static/media/timestamp.f79acd50.svg";